import { styled } from '@mui/material/styles';
import {
    Box,
    TextField,
    Button,
    TableContainer,
    Paper,
    TableCell,
    TableRow,
    Typography,
} from '@mui/material';

//Define un Box estilizado para el contenedor principal
export const StyledMainContainer = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(2), // Usa el spacing del tema
    backgroundColor: '#f9f9f9',
}));

//Define un Box estilizado para el contenedor del título
export const StyledHeaderWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(4), // Usa el spacing del tema
}));

//Define un Typography estilizado para el título "Usuarios"
export const StyledPageTitle = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(2), // Usa el spacing del tema
}));

// Define un componente Box estilizado para la barra de Busqueda
//y boton crear
export const StyledActionsBar = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3), // Usa el espaciado del tema de MUI
    gap: theme.spacing(2), // Usa el espaciado del tema de MUI

    // Estilos específicos para el botón "Crear Usuario" dentro de esta barra
    '& .MuiButton-root': { // Selecciona el componente Button
        whiteSpace: 'nowrap',
        minWidth: '150px',
    },

    // Puedes añadir estilos responsivos si es necesario
    [theme.breakpoints.down('sm')]: { // Por ejemplo, en pantallas pequeñas
        flexDirection: 'column', // Los elementos se apilan
        alignItems: 'stretch',   // Se estiran para ocupar todo el ancho
        '& .MuiButton-root': {
            width: '100%', // El botón ocupa todo el ancho
            minWidth: 'unset', // Quita el minWidth fijo
        },
        '& .MuiTextField-root': {
            marginBottom: theme.spacing(2), // Espacio entre TextField y Button
        }
    },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius * 2, // Usa el radio de borde del tema
    boxShadow: theme.shadows[1], // Usa la sombra de elevación del tema
}));

export const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
}));

export const StyledTableLinkCell = styled(TableCell)(({ theme }) => ({
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
}));

export const StyledNoUsersCell = styled(TableCell)(({ theme }) => ({
    textAlign: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
}));

// Componente de Paper estilizado
export const StyledPaper = styled(Paper)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[1],
}));

export const disabledInputBlackTextSx = {
    '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: 'black',
        color: 'black',
    },
};